<div class="sx-guide">
  <div *ngIf="guide.pages.length > 1">
    <mat-horizontal-stepper #stepper [selectedIndex]="pageNumber" (selectionChange)="pageChange($event)">
      <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
      <ng-template matStepperIcon="done" let-index="index">{{ index + 1 }}</ng-template>
      <ng-template matStepperIcon="number" let-index="index">{{ index + 1 }}</ng-template>

      <div *ngFor="let page of guide.pages">
        <mat-step [ngClass]="{'sx-guide__active': page.isSelected}">
          <div class="sx-guide__content">
            <img class="sx-guide__image" src="{{ page.image }}" *ngIf="page.image">
            <div class="sx-guide__text">
              <h3 *ngIf="page.heading" [innerHTML]="page.heading"></h3>
              <div *ngIf="page.mainText" [innerHTML]="page.mainText | safeHtml" appRouterLink></div>
            </div>
          </div>
        </mat-step>
      </div>
    </mat-horizontal-stepper>
  </div>

  <div *ngIf="guide.pages.length === 1">
    <div class="sx-guide__content">
      <img class="sx-guide__image" src="{{ guide.pages[0].image }}" *ngIf="guide.pages[0].image">
      <div class="sx-guide__text">
        <h3 *ngIf="guide.pages[0].heading" [innerHTML]="guide.pages[0].heading"></h3>
        <div *ngIf="guide.pages[0].mainText" [innerHTML]="guide.pages[0].mainText | safeHtml" appRouterLink></div>
      </div>
    </div>
  </div>

  <div class="sx-guide__button-panel">
    <button mat-button class="sx-button sx-guide__button" (click)="prevPage()" id="guide_prev_btn" [ngClass]="{'sx-guide__invisible': guide.pages.length === 1 || pageNumber === 0}">
      {{ 'core.help.guides.previous' | translate }}
    </button>

    <button mat-button class="sx-button sx-button--magenta sx-button--wide sx-guide__cancel-button" (click)="onCancel()" id="guide_close_btn">
      {{ 'core.help.guides.close' | translate }}
    </button>

    <button mat-button class="sx-button sx-guide__button" (click)="nextPage()" id="guide_next_btn" [ngClass]="{'sx-guide__invisible': guide.pages.length === 1 || pageNumber === (guide.pages.length - 1)}">
      {{ 'core.help.guides.next' | translate }}
    </button>
  </div>
</div>
